import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Navbar from '../componen/navbar/Navbar';
import Sidebar from '../componen/sidebar/SideBar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Footer from '../componen/Footer';

export const Layout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Track window width changes
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Close sidebar on smaller screens when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        windowWidth <= 799 &&
        isSidebarOpen &&
        !event.target.closest('.sidebar-container')
      ) {
        setIsSidebarOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isSidebarOpen, windowWidth]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
      {/* Sidebar */}
      <Box
        className="sidebar-container"
        sx={{
          zIndex: 1200,
          width: 300,
          flexShrink: 0,
          '@media (max-width:799px)': {
            display: isSidebarOpen ? 'block' : 'none',
            position: 'fixed',
            height: '100%',
            backgroundColor: 'background.paper',
            boxShadow: 3,
          },
          '@media (min-width:800px)': {
            display: 'block',
            position: 'relative',
          },
        }}
      >
        <Sidebar />
      </Box>

      {/* Main Content Area */}
      <Box 
        sx={{ 
          flex: 1, 
          display: 'flex', 
          flexDirection: 'column', 
          overflow: 'hidden',
          width: { xs: '100%', md: `calc(100% - ${isSidebarOpen ? '300px' : '0px'})` },
          ml: { md: isSidebarOpen ? '300px' : '0px' },
          transition: 'margin-left 0.3s ease-in-out',
        }}
      >
        {/* Navbar */}
        <Box
          sx={{
            position: 'sticky',
            top: 0,
            zIndex: 1100,
            backgroundColor: 'white',
            boxShadow: 1,
          }}
        >
          <Navbar>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{
                '@media (min-width:800px)': {
                  display: 'none',
                },
              }}
              onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            >
              <MenuIcon />
            </IconButton>
          </Navbar>
        </Box>

        {/* Content */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            overflowY: 'auto',
            backgroundColor: 'var(--mui-palette-background-default)',
            padding: { xs: 2, sm: 3 },
            width: '100%',
            // Special handling for exactly 890px width
            '@media (max-width: 890px)': {
              padding: 1.5,
            }
          }}
        >
          {children}
        </Box>

        {/* Footer (commented out as in your original code) */}
        {/* <Box
          sx={{
            position: 'sticky',
            bottom: 0,
            zIndex: 1100,
            backgroundColor: 'white',
            boxShadow: 1,
          }}
        >
          <Footer />
        </Box> */}
      </Box>
    </Box>
  );
};

export default Layout;